/**
 * Transform response object to array format
 */
export const transformResponseToArr = <T extends object>(response: T) => {
  const entries = Object.values(response).map((value) => ({ id: value.id, label: value.label }));
  return entries;
};
